module.exports = __webpack_public_path__ + "img/alert-circle@1x.60a2fb7d.svg";